export default "__VITE_ASSET__CICkg2$L__"